
import { Vue, Options } from 'vue-class-component'
import { maska } from 'maska'
import { Prop } from 'vue-property-decorator'
import {
  IFlexMessageBox,
  IFlexMessageBubble,
  IFlexMessageButton,
  IFlexMessageCarousel,
  IFlexMessageFiller,
  IFlexMessageIcon,
  IFlexMessageImage,
  IFlexMessageSeparator,
  IFlexMessageSpan,
  IFlexMessageText,
  IFlexMessageVideo,
} from '@/utils/types'
import FlexMessageBubbleTree from '@/components/common/flex-message/FlexMessageBubbleTree.vue'
import FlexMessageBubble from '@/components/common/flex-message/FlexMessageBubble.vue'

@Options({
  components: { FlexMessageBubble, FlexMessageBubbleTree },
  directives: { maska },
  emits: ['update:modelValue', 'onSelectNode', 'onHoverNode'],
})
export default class FlexMessageTree extends Vue {
  @Prop()
  modelValue!: IFlexMessageBubble | IFlexMessageCarousel

  @Prop()
  selectedNode!: IFlexMessageCarousel | IFlexMessageBubble | IFlexMessageBox | IFlexMessageButton | IFlexMessageFiller | IFlexMessageIcon | IFlexMessageImage | IFlexMessageSeparator | IFlexMessageSpan | IFlexMessageText | IFlexMessageVideo

  @Prop()
  selectedPath!: string

  @Prop()
  type!: string

  @Prop()
  errorPath!: string[]

  showChild = true

  get value() {
    return this.modelValue
  }

  set value(value: IFlexMessageBubble | IFlexMessageCarousel) {
    this.$emit('update:modelValue', value)
  }

  selectNode(node, path) {
    if (this.selectedNode === node && this.selectedPath === path) {
      this.$emit('onSelectNode', undefined, '')
    } else {
      this.$emit('onSelectNode', node, path)
    }
  }
}
